import React from 'react';

function emailLink() {
  return <a href="mailto:team@sevenloves.co.uk">team@sevenloves.co.uk</a>;
}

function externalLink(href, label) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {label}
    </a>
  );
}

const tr = {
  languageSwitcher: {
    label: 'Dil',
    options: {
      en: 'EN',
      ja: 'JA',
      ko: 'KO',
      ms: 'MS',
      th: 'TH',
      tr: 'TR',
    },
    names: {
      en: 'İngilizce',
      ja: 'Japonca',
      ko: 'Korece',
      ms: 'Malayca',
      th: 'Tayca',
      tr: 'Türkçe',
    },
  },
  nav: {
    home: 'Ana Sayfa',
    privacy: 'Gizlilik',
    terms: 'Koşullar',
    smsOptIn: 'SMS Onayı',
    guidelines: 'Kurallar',
    safety: 'Güvenlik',
    deleteAccount: 'Hesabı Sil',
    support: 'Destek',
    download: 'İndir',
    brandAriaLabel: '7Loves Ana Sayfa',
    menuAriaLabel: 'Menüyü aç',
  },
  store: {
    groupAriaLabel: 'Mağaza bağlantıları',
    appStoreAriaLabel: "App Store'dan indir",
    appStoreOverline: "App Store'dan",
    appStoreTitle: 'İndir',
    googlePlayAriaLabel: "Google Play'de bul",
    googlePlayOverline: "Google Play'de",
    googlePlayTitle: 'İndir',
  },
  home: {
    metaTitle: 'Ana Sayfa',
    title: "7Loves'a Hoş Geldiniz",
    subtitle: 'Blind Date - Önce eşleş, daha fazlasını sonra keşfet.',
    intro:
      'Seven Loves, anlamlı bağlara odaklanan modern bir flört uygulamasıdır. Geleneksel kaydırma tabanlı uygulamalardan farklı olarak Seven Loves, kullanıcıların önce bağlantı kurduğu ve profilleri zamanla açtığı özgün bir kör eşleşme deneyimi sunar.',
    howItWorks: 'Nasıl Çalışır',
    details:
      'Kullanıcılar uyumluluğa göre eşleştirilir, sohbet etmeye başlar ve zaman içinde profil detaylarının kilidini açar. Bu yaklaşım, yüzeysel kaydırmalar yerine daha gerçek bağları teşvik eder.',
    primaryCta: 'İndir',
    secondaryCta: 'Bize Ulaşın',
  },
  downloadPage: {
    metaTitle: 'İndir',
    title: '7Loves’u İndir',
    subtitlePrefix: 'Buradan',
    subtitleSuffix: 'devam edebilirsin.',
    fallback: 'İstersen aşağıdaki mağaza linklerini de kullanabilirsin.',
    modalTitle: 'Mağaza açılsın mı?',
    modalBodyPrefix: 'Bu cihazda',
    modalBodySuffix: 'açmayı deneyebiliriz.',
    primaryCta: 'Mağazayı Aç',
    secondaryCta: 'Şimdi Değil',
    backHome: 'Ana Sayfaya Dön',
    destinations: {
      ios: "App Store'u",
      android: 'Google Play’i',
    },
  },
  smsOptIn: {
    metaTitle: 'SMS Doğrulama Onayı',
    title: 'SMS Doğrulama Onayı',
    subtitle:
      "Tek kullanımlık doğrulama kodu almak için lütfen 18 yaşından büyük olduğunuzu onaylayın ve cep telefonu numaranızı girin.",
    dobLabel: 'Doğum Tarihi (GG/AA/YYYY)',
    dayPlaceholder: 'GG',
    monthPlaceholder: 'AA',
    yearPlaceholder: 'YYYY',
    phoneLabel: 'Cep Telefonu Numarası',
    phonePlaceholder: '+90 5xx xxx xx xx',
    sendCode: 'Doğrulama Kodunu Gönder',
    disclosure:
      '“Doğrulama Kodunu Gönder” seçeneğine dokunarak 18 yaşında veya daha büyük olduğunuzu onaylar ve kimlik doğrulama amacıyla Seven Loves tarafından gönderilecek tek kullanımlık SMS doğrulama kodlarını almayı kabul edersiniz. Mesaj ve veri ücretleri uygulanabilir. Pazarlama mesajı gönderilmez.',
    privacyLink: 'Gizlilik Politikası',
  },
  pages: {
    privacy: {
      metaTitle: 'Gizlilik Politikası',
      title: '7Loves Gizlilik Politikası',
      subtitle: (
        <>
          Gizliliğiniz, sorumluluğumuzdur.
          <br />
          Bu sayfa, kişisel verilerinizin Seven Loves Limited ("7Loves") tarafından nasıl
          işlendiğini ve korunduğunu açıklar.
        </>
      ),
      sections: [
        {
          title: '1. Giriş',
          blocks: [
            {
              type: 'paragraph',
              content: (
                <>
                  7Loves Gizlilik Politikası'na hoş geldiniz.
                  <br />
                  Verilerinizi korumaya ve yalnızca açık, meşru amaçlarla kullanmaya kararlıyız.
                  Verilerinizin 7Loves üzerinde nasıl işlendiği, saklandığı ve korunduğuna dair
                  ayrıntılı açıklama için lütfen bu politikayı dikkatle okuyun.
                </>
              ),
            },
          ],
        },
        {
          title: '2. Veri Sorumlusu',
          blocks: [
            {
              type: 'paragraph',
              content: (
                <>
                  Verileriniz, Birleşik Krallık Richmond Office adresinde bulunan Seven Loves
                  Limited tarafından işlenmektedir. Kişisel verilerinizle ilgili talepleriniz veya
                  sorularınız için bizimle <b>team@sevenloves.co.uk</b> adresinden iletişime
                  geçebilirsiniz.
                </>
              ),
            },
          ],
        },
        {
          title: '3. Toplanan Kişisel Veri Kategorileri',
          blocks: [
            {
              type: 'paragraph',
              content: '7Loves tarafından işlenen kişisel veri kategorileri şunlardır:',
            },
            {
              type: 'list',
              items: [
                <>
                  <b>Kimlik Bilgileri:</b> Ad, soyad, doğum tarihi, boy
                </>,
                <>
                  <b>İletişim Bilgileri:</b> Apple ID, telefon numarası
                </>,
                <>
                  <b>Görsel Veriler:</b> Profil fotoğrafları (6 bölüm halinde işlenir ve
                  bulanıklaştırılır)
                </>,
                <>
                  <b>İlişki ve Aile Bilgileri:</b> Çocuk sahibi olma durumu ve ilişki tercihleri
                </>,
                <>
                  <b>Mesajlar:</b> Tüm kullanıcılar arası mesajlar (arşivlenir)
                </>,
                <>
                  <b>Konum:</b> İzin verilmesi halinde cihazın coğrafi konumu
                </>,
                <>
                  <b>Kullanım ve Teknik Veriler:</b> Cihaz bilgileri, IP adresi, uygulama
                  etkinlikleri ve etkileşimler
                </>,
              ],
            },
          ],
        },
        {
          title: '4. Veri İşlemenin Hukuki Dayanağı ve Amaçları',
          blocks: [
            {
              type: 'list',
              items: [
                'Hesabınızı ve kullanıcı profilinizi oluşturmak ve yönetmek',
                'Sizi diğer kullanıcılarla eşleştirmek ve iletişimi kolaylaştırmak',
                'Uygulama özelliklerini ve hizmetleri sunmak ve sürdürmek',
                'Kullanımı analiz etmek ve hizmet kalitesini artırmak',
                'Güvenliği, dolandırıcılığın önlenmesini ve yasal yükümlülüklere uyumu sağlamak',
                'Daha iyi eşleştirme ve güvenlik için yapay zeka ve makine öğrenmesi sistemlerini geliştirmek, test etmek ve iyileştirmek',
              ],
            },
            {
              type: 'paragraph',
              content:
                'Verilerinizi açık rızanıza, hizmet sözleşmesinin ifasına ve yasal yükümlülüklerimize uyum sağlama gerekçelerine dayanarak işleriz.',
            },
          ],
        },
        {
          title: '5. Veri Paylaşımı ve Aktarımlar',
          blocks: [
            {
              type: 'list',
              items: [
                'Verilerinizin bir kısmı diğer kullanıcılara görünür olabilir (örneğin profil fotoğrafları ve eşleşme verileri).',
                'Veriler; hizmet sunumu ve güvenlik amacıyla güvenilir hizmet sağlayıcılarla (bulut barındırma, moderasyon, ödeme işleme) paylaşılabilir.',
                'Yasa gerektirdiğinde veriler yetkili kamu kurumlarıyla paylaşılabilir.',
                'Yeterli güvenceler olmadan Birleşik Krallık/AB dışına veri aktarımı yapılmaz.',
                'Güvenliğiniz ve platform bütünlüğü için, bazen üçüncü taraf sağlayıcılarla birlikte otomatik moderasyon araçları (örneğin görsel/AI moderasyonu) kullanılabilir.',
              ],
            },
          ],
        },
        {
          title: '6. Veri Saklama Süreleri',
          blocks: [
            {
              type: 'list',
              items: [
                'Tüm kullanıcı verileri, yukarıda belirtilen amaçlar için artık gerekli olmadığında veya hesabınızı sildiğinizde silinir ya da anonim hale getirilir; yasal yükümlülükler daha uzun süre saklamayı gerektirmedikçe bu kural geçerlidir.',
                <>
                  Veriler, <b>hesap kapatıldıktan sonra 3 ay</b> ve <b>hesap yasaklandıktan sonra
                  1 yıl</b> saklanır.
                </>,
                <>
                  Onay kayıtlarınız (örneğin koşulların veya gizlilik politikasının kabulü) yasal
                  yükümlülüklere uyum için <b>5 yıl</b> saklanır.
                </>,
                <>
                  Müşteri hizmetleri yazışmaları, uyuşmazlık çözümü ve yasal uyum amacıyla son
                  iletişimden sonra <b>6 yıl</b> saklanır.
                </>,
                <>
                  Olası hukuki talepler için profil ve eşleşme verileri silme işleminden sonra{' '}
                  <b>1 yıl</b> saklanır.
                </>,
                <>
                  Yasaklanan kullanıcılar için asgari düzeyde veri, kullanıcı topluluğunun
                  güvenliğini korumak amacıyla <b>10 yıla kadar</b> saklanabilir.
                </>,
                'Bekleyen bir uyuşmazlık veya hukuki talep varsa, veriler uyuşmazlık çözülene kadar saklanabilir.',
              ],
            },
          ],
        },
        {
          title: '7. Çocukların Gizliliği',
          blocks: [
            {
              type: 'paragraph',
              content: (
                <>
                  7Loves yalnızca 18 yaş ve üzeri kullanıcılar için tasarlanmıştır.
                  <br />
                  18 yaş altındaki kullanıcıların hizmeti kullanmasına izin verilmez. Reşit olmayan
                  bir kişiye ait olduğu tespit edilen her hesap silinir. Lütfen uygulama içi
                  araçlarımız üzerinden reşit olmayan kullanıcıları bildirin.
                </>
              ),
            },
          ],
        },
        {
          title: '8. Güvenlik ve Otomatik Filtreleme',
          blocks: [
            {
              type: 'list',
              items: [
                'Zararlı, yasa dışı veya uygunsuz içerik ve davranışları tespit etmek için otomatik filtreler ve yapay zeka moderasyon araçları kullanılır.',
                'Herhangi bir ihlal, hesabın askıya alınmasına, içeriğin kaldırılmasına veya yetkililere bildirilmesine yol açabilir.',
                'Kullanıcı raporları ve şikayetleri ciddiyetle ele alınır ve hem otomatik hem de insan incelemesiyle işlenir.',
              ],
            },
          ],
        },
        {
          title: '9. Profilleme ve Otomatik Karar Verme',
          blocks: [
            {
              type: 'list',
              items: [
                'İlgili profilleri önermek ve güvenliği artırmak için otomatik eşleştirme algoritmaları ve yapay zeka kullanılır.',
                'Hassas özellikler (ırk, din ve benzeri nitelikler) eşleştirme veya otomatik kararlarda kullanılmaz.',
                'Önemli kararlar (örneğin hesap yasakları) talep üzerine her zaman bir insan tarafından gözden geçirilebilir.',
              ],
            },
          ],
        },
        {
          title: '10. Haklarınız',
          blocks: [
            {
              type: 'list',
              items: [
                <>
                  <b>Erişim:</b> İşlenen verileriniz hakkında istediğiniz zaman bilgi talep
                  edebilirsiniz.
                </>,
                <>
                  <b>Düzeltme:</b> Yanlış veya eksik verilerin düzeltilmesini talep edebilirsiniz.
                </>,
                <>
                  <b>Silme ("Unutulma Hakkı"):</b> Belirli koşullar altında verilerinizin
                  silinmesini talep edebilirsiniz.
                </>,
                <>
                  <b>Kısıtlama:</b> Belirli durumlarda veri işlemenin sınırlandırılmasını talep
                  edebilirsiniz.
                </>,
                <>
                  <b>Bildirim:</b> Düzeltmeler veya silmeler hakkında bilgilendirilme hakkına
                  sahipsiniz.
                </>,
                <>
                  <b>Taşınabilirlik:</b> Verilerinizi taşınabilir bir formatta talep edebilir veya
                  başka bir hizmet sağlayıcısına aktarılmasını isteyebilirsiniz.
                </>,
                <>
                  <b>İtiraz:</b> Doğrudan pazarlama veya diğer meşru menfaatlere dayalı işleme
                  faaliyetlerine itiraz edebilirsiniz.
                </>,
                <>
                  <b>Otomatik kararlar:</b> Yalnızca otomatik yollarla alınan kararlara itiraz etme
                  hakkınız vardır.
                </>,
              ],
            },
            {
              type: 'paragraph',
              content: (
                <>
                  Tüm veri hakları talepleri için lütfen <b>team@sevenloves.co.uk</b> adresine
                  e-posta gönderin.
                  <br />
                  Memnun kalmazsanız, Birleşik Krallık Bilgi Komiserliği Ofisi'ne (ICO) şikayette
                  bulunabilirsiniz.
                </>
              ),
            },
          ],
        },
        {
          title: '11. İletişim ve Şikayetler',
          blocks: [
            {
              type: 'paragraph',
              content: (
                <>
                  Bu politika veya kişisel verileriniz hakkında sorularınız varsa bizimle{' '}
                  <b>team@sevenloves.co.uk</b> adresinden ya da [ADDRESS], United Kingdom posta
                  adresinden iletişime geçebilirsiniz.
                  <br />
                  Ayrıca Bilgi Komiserliği Ofisi'ne ({externalLink('https://ico.org.uk/', 'ico.org.uk')})
                  şikayette bulunma hakkınız da vardır.
                </>
              ),
            },
          ],
        },
        {
          title: '12. Bu Gizlilik Politikasındaki Güncellemeler',
          blocks: [
            {
              type: 'paragraph',
              content: (
                <>
                  Bu politika zaman zaman güncellenebilir. Önemli değişiklikler uygulama içinden
                  veya e-posta yoluyla size bildirilecektir. En güncel sürüm her zaman{' '}
                  <b>https://sevenloves.com/privacy</b> adresinde yer alacaktır.
                </>
              ),
            },
          ],
        },
      ],
    },
    terms: {
      metaTitle: 'Hizmet Koşulları',
      title: '7Loves Hizmet Koşulları',
      subtitle:
        "Lütfen 7Loves'u kullanmadan önce bu koşulları dikkatle okuyun. Uygulamamıza/web sitemize erişerek veya bunları kullanarak bu Hizmet Koşulları'nı kabul etmiş olursunuz.",
      sections: [
        {
          title: '1. Giriş',
          blocks: [
            {
              type: 'paragraph',
              content: (
                <>
                  7Loves Hizmet Koşulları'na ("Koşullar" veya "Sözleşme") hoş geldiniz. Bu
                  Sözleşme, siz ve <b>Seven Loves Limited</b> ("7Loves") arasında bağlayıcı bir
                  sözleşmedir. 7Loves uygulamasını veya web sitesini ("7Loves" veya "Uygulama")
                  kullanmadan önce lütfen bu Koşullar'ı, Gizlilik Politikamızı, Çerez Politikamızı
                  ve Topluluk Kurallarımızı inceleyin. 7Loves'a erişerek, görüntüleyerek veya
                  kullanarak bu Koşullar'a ve politikalarımıza bağlı olmayı kabul etmiş olursunuz.
                  Kabul etmiyorsanız hizmetlerimizi kullanmayı bırakmalısınız.
                </>
              ),
            },
            {
              type: 'paragraph',
              content: (
                <>
                  7Loves hizmetleri <b>Seven Loves Limited</b> tarafından <b>Richmond Office</b>{' '}
                  adresinden sunulmaktadır. Bu Koşullar'ı herhangi bir zamanda güncelleyebilir veya
                  değiştirebiliriz; bu değişiklikler güncellenmiş yürürlük tarihiyle birlikte bu
                  sayfada yayınlanır. Bazı durumlarda sizi e-posta ile bilgilendirebiliriz.
                  Değişikliklerden sonra hizmeti kullanmaya devam etmeniz, güncellenen Koşullar'ı
                  kabul ettiğiniz anlamına gelir. Değişiklikleri kabul etmiyorsanız hizmeti
                  derhal kullanmayı bırakmalısınız.
                </>
              ),
            },
          ],
        },
        {
          title: '2. Uygunluk ve Kullanıcı Taahhütleri',
          blocks: [
            {
              type: 'list',
              items: [
                'En az 18 yaşında olmalısınız.',
                'Bu sözleşmeyi yapabilecek hukuki ehliyete sahip olmalı ve yasalar gereği hizmeti kullanmanız yasak olmamalıdır.',
                "7Loves'ta yalnızca bir hesap bulundurabilirsiniz.",
                'Ciddi, şiddet içeren veya cinsel bir suçtan mahkum olmamış olmalısınız; ancak şiddet içermeyen bir suç için affedilmiş olmanız ve başkaları için tehdit oluşturmamanız durumu hariçtir.',
              ],
            },
            {
              type: 'paragraph',
              content:
                "Bu kriterleri karşılamıyorsanız veya sonradan karşılamamaya başlarsanız, 7Loves'a erişim hakkınız otomatik olarak sona erer ve hesabınız silinmelidir. Erişimi bildirim yapmadan kaldırma hakkımız saklıdır.",
            },
            {
              type: 'paragraph',
              content: 'Ayrıca şunları kabul edersiniz:',
            },
            {
              type: 'list',
              items: [
                'Gizlilik, fikri mülkiyet, istenmeyen ileti önleme ve diğer ilgili düzenlemeler dahil olmak üzere yürürlükteki tüm yasa ve yönetmeliklere uymak.',
                'Yalnızca uygulamanın/web sitesinin en güncel sürümünü kullanmak.',
                'Topluluk Kurallarımızı düzenli olarak incelemek ve bunlara uymak.',
                'Giriş bilgilerinizi gizli tutmak için gerekli tüm adımları atmak.',
              ],
            },
          ],
        },
        {
          title: '3. Kullanım Kısıtlamaları',
          blocks: [
            {
              type: 'paragraph',
              content: (
                <>
                  7Loves'u kullanırken aşağıdakileri <b>yapmamayı</b> kabul edersiniz:
                </>
              ),
            },
            {
              type: 'list',
              items: [
                'Kimliğiniz, yaşınız veya ilişkileriniz hakkında yanıltıcı, yanlış veya sahte bilgi vermek.',
                'Hizmeti platforma, sunuculara veya diğer kullanıcılara zarar verecek ya da işleyişi bozacak şekilde kullanmak.',
                'Kara para aklama veya finansal suçlar dahil olmak üzere hizmeti yasa dışı, kötü niyetli veya zararlı amaçlarla kullanmak.',
                'Taciz, tehdit, ısrarlı takip, iftira veya kötüye kullanım içeren davranışlarda bulunmak.',
                'Yasalarca yasaklanan içerikleri paylaşmak, iletmek veya dağıtmak.',
                'Diğer kullanıcılardan parola veya kişisel bilgi istemek ya da başkalarının bilgilerini rıza olmadan açıklamak.',
                'Kullanıcılardan para veya değerli eşya istemek ya da talep etmek.',
                'Başka bir kullanıcının hesabını kullanmak veya başkalarının sizin hesabınızı kullanmasına izin vermek.',
                'Dolandırıcılık, saadet zinciri veya yasa dışı gelir modellerine katılmak.',
                'Kişisel siyasi görüş paylaşımı hariç, hizmeti siyasi kampanya finansmanı veya seçimleri etkileme amacıyla kullanmak.',
                'Paylaşma hakkınız olmayan gizli veya özel bilgileri açıklamak.',
                "7Loves veya üye içeriklerini açık izin olmadan kopyalamak, değiştirmek, dağıtmak ya da türev çalışmalar oluşturmak.",
                "Resmi olarak yetkilendirilmedikçe 7Loves tarafından desteklendiğinizi ima etmek veya söylemek.",
                'Platforma erişmek veya etkileşim kurmak için otomatik araçlar (botlar, kazıyıcılar ve benzeri yöntemler) kullanmak ya da sistemlerimizi aşmaya çalışmak.',
                'Virüs, zararlı yazılım veya zararlı kod yüklemek.',
                'Bilginin kaynağını gizlemek için başlıkları veya tanımlayıcıları taklit etmek.',
                "Kullanıcıları başka yerlere yönlendirmek amacıyla 7Loves'a referans veren meta etiketler, kodlar veya cihazlar kullanmak.",
                "İzin olmadan 7Loves'un kaynak koduna veya arayüzlerine erişmeye, bunları yayımlamaya, tersine mühendislik yapmaya ya da şifresini çözmeye çalışmak.",
                'Yazılı onay olmadan hizmetimiz veya içeriğimizle etkileşim kurmak için yapay zeka ya da üçüncü taraf uygulamalar kullanmak.',
                'Sistemlerimizin veya ağlarımızın güvenlik açıklarını araştırmak, taramak veya test etmek.',
                'Bu Koşulların ihlal edilmesini teşvik etmek veya desteklemek.',
                'Askıya alma veya fesih sonrasında izin almadan yeni bir hesap oluşturmak.',
                'Şikayet/bildirim sistemlerimizi kötüye kullanmak.',
              ],
            },
            {
              type: 'paragraph',
              content:
                "Herhangi bir ihlal, 7Loves'a erişiminizi derhal kaybetmenize neden olabilir.",
            },
          ],
        },
        {
          title: '4. İçerik Türleri ve Sorumluluklar',
          blocks: [
            {
              type: 'list',
              items: [
                <>
                  <b>Sizin İçeriğiniz:</b> Profiliniz üzerinden yüklediğiniz veya sağladığınız
                  içerik (Topluluk Kuralları'na ve bu Koşullar'a uygun olmalıdır).
                </>,
                <>
                  <b>Üye İçeriği:</b> Diğer kullanıcılar tarafından sağlanan içerik (7Loves bunun
                  doğruluğunu garanti etmez).
                </>,
                <>
                  <b>Bizim İçeriğimiz:</b> 7Loves tarafından sağlanan içerik (telif hakkı ve marka
                  hukuku ile korunur).
                </>,
              ],
            },
            {
              type: 'subheading',
              content: 'Yasaklı içerikler şunları içerir (bunlarla sınırlı olmamak üzere):',
            },
            {
              type: 'list',
              items: [
                'Saldırgan, kötüye kullanıma açık veya psikolojik olarak rahatsız edici içerik.',
                'Müstehcen, pornografik, şiddet içeren veya çıplaklık barındıran içerik.',
                'Tehditkar, ayrımcı, nefret dolu veya fanatik içerik.',
                'Yasa dışı faaliyetleri, terörü, nefreti veya suçları teşvik eden içerik.',
                'Kendine zarar vermeyi, yeme bozukluklarını, tehlikeli akımları veya şiddet içeren aşırılığı teşvik eden içerik.',
                'İftira niteliğinde, aşağılayıcı veya yanlış bilgi içeren içerik.',
                'Ticari faaliyetler, promosyonlar, reklamlar veya seks işçiliği ya da "sugar dating" talepleri.',
                'Spam veya spam yapılmasını kolaylaştıran içerik.',
                'Sistemlere zarar vermek veya veri çalmak amacı taşıyan virüsler, kötü amaçlı yazılımlar, casus yazılımlar, solucanlar veya diğer kodlar.',
                'Üçüncü taraf haklarını ihlal eden içerik.',
                'Başkalarına ait izinsiz görseller, özellikle de küçüklere ait olanlar.',
                "Platformun amaçlanan kullanımına uygun olmayan veya 7Loves'un ya da iştiraklerinin itibarına zarar veren herhangi bir içerik.",
              ],
            },
            {
              type: 'paragraph',
              content:
                "İçeriğinizden siz sorumlusunuz ve bundan doğan taleplerden yükümlü tutulabilirsiniz. Profilinizde kişisel/banka/ödeme bilgisi paylaşmanız kendi riskinizdedir. 7Loves'a yüklenen içerik başkalarına görünür olabilir ve gerekli görüldüğünde içeriğinizi kullanmak, düzenlemek, kopyalamak, uyarlamak veya kaldırmak için 7Loves'a dünya çapında, telifsiz, münhasır olmayan ve sürekli bir lisans vermiş olursunuz.",
            },
          ],
        },
        {
          title: '5. Bildirim ve Moderasyon',
          blocks: [
            {
              type: 'paragraph',
              content:
                'Uygunsuz veya yasaklı içerik ya da davranışlar hesabın askıya alınmasına veya sonlandırılmasına neden olabilir. İçerikleri veya kullanıcıları uygulama içi "Bildir" özellikleri üzerinden ya da bizimle iletişime geçerek bildirebilirsiniz. İçerikleri kaldırma veya başka aksiyonlar alma konusunda takdir yetkisi bize aittir ve gerektiğinde kolluk kuvvetleriyle iş birliği yapabiliriz.',
            },
          ],
        },
        {
          title: '6. Gizlilik',
          blocks: [
            {
              type: 'paragraph',
              content:
                'Kişisel verilerinizi nasıl topladığımız, kullandığımız ve paylaştığımız hakkında bilgi için lütfen Gizlilik Politikamızı inceleyin. Hizmetimizi kullanarak, kişisel verilerinizin Gizlilik Politikamız doğrultusunda işlenmesini kabul edersiniz.',
            },
          ],
        },
        {
          title: '7. Hesabın Askıya Alınması veya Sonlandırılması',
          blocks: [
            {
              type: 'paragraph',
              content:
                'Koşullarımızın veya Topluluk Kurallarımızın ihlali ya da uygunsuz veya yasa dışı saydığımız herhangi bir davranış, hesabınızın askıya alınmasına veya sonlandırılmasına neden olabilir. Ayrıca uygulamadaki "Hesabı Sil" özelliği üzerinden hesabınızı istediğiniz zaman silebilirsiniz.',
            },
            {
              type: 'paragraph',
              content:
                "7Loves, önceden bildirim yapmaksızın veya sorumluluk üstlenmeksizin erişimi kısıtlama, hesapları sonlandırma ya da teknik, hukuki veya diğer önlemleri kullanma hakkını saklı tutar. Sonlandırma size herhangi bir geri ödeme hakkı vermez; verileriniz Gizlilik Politikamız doğrultusunda saklanır veya silinir.",
            },
          ],
        },
        {
          title: '8. Feragatler ve Sorumluluğun Sınırlandırılması',
          blocks: [
            {
              type: 'paragraph',
              content:
                'Uygulama, web sitesi, içeriğimiz ve üye içerikleri "olduğu gibi" ve "mevcut olduğu şekliyle", herhangi bir garanti olmaksızın sunulur. 7Loves; hizmetin beklentilerinizi karşılayacağını, hatasız, güvenli veya kesintisiz olacağını ya da eşleşmelerin güvenilir veya doğru olacağını garanti etmez. Hizmeti kullanmanız kendi riskinizdedir ve diğer kullanıcılarla yaptığınız tüm etkileşim ve iletişimlerden yalnızca siz sorumlusunuz. Kullanıcı davranışlarından, üye içeriklerinin doğruluğundan veya platformu kullanımınızdan doğan kayıp, zarar ya da uyuşmazlıklardan sorumlu değiliz.',
            },
            {
              type: 'paragraph',
              content:
                'Üçüncü taraf web sitelerine veya içeriklere verilen bağlantılar kolaylık amacıyla sağlanır; 7Loves bu siteleri onaylamaz veya kontrol etmez ve içeriklerinden, gizlilik uygulamalarından ya da koşullarından sorumlu değildir. Üçüncü taraf sitelere erişim kendi riskinizdedir.',
            },
            {
              type: 'paragraph',
              content:
                'Yürürlükteki hukuk kapsamında hariç tutulamayan zımni garantiler veya sorumluluklar varsa, sorumluluğumuz yasanın izin verdiği asgari ölçüyle sınırlı olacaktır.',
            },
          ],
        },
        {
          title: '9. Uyuşmazlıkların Çözümü',
          blocks: [
            {
              type: 'paragraph',
              content:
                'Bu Koşullar İngiltere ve Galler yasalarına tabidir. Tüm uyuşmazlıklar öncelikle dostane şekilde çözülmeye çalışılacaktır. Çözüm mümkün olmazsa taraflardan biri İngiltere mahkemelerinde hukuki yollara başvurabilir.',
            },
          ],
        },
        {
          title: '10. Son Hükümler',
          blocks: [
            {
              type: 'paragraph',
              content:
                'Bu Koşullar, hizmetin kullanımına ilişkin olarak sizinle 7Loves arasındaki anlaşmanın tamamını oluşturur ve önceki tüm anlaşma veya beyanların yerine geçer (Gizlilik Politikası hariç). Herhangi bir hükmün uygulanamaz bulunması, diğer hükümlerin yürürlükte kalmasını etkilemez.',
            },
            {
              type: 'paragraph',
              content:
                "7Loves bu Koşullar'ı istediği zaman güncelleyebilir veya değiştirebilir. Değişiklikler bu sayfada yayınlanır ve size e-posta yoluyla veya uygulama içinde bildirilebilir. Koşulları düzenli olarak gözden geçirmek sizin sorumluluğunuzdadır. Değişikliklerden sonra kullanıma devam etmeniz, güncellenmiş Koşullar'ı kabul ettiğiniz anlamına gelir.",
            },
            {
              type: 'paragraph',
              content:
                "7Loves'a kayıt olarak bu sözleşmenin tüm koşullarını kabul ettiğinizi onaylarsınız. Bu Koşullar kayıt olduğunuz anda yürürlüğe girer ve sizinle 7Loves arasında bağlayıcı bir hukuki ilişki oluşturur.",
            },
          ],
        },
      ],
    },
    communityGuidelines: {
      metaTitle: 'Topluluk Kuralları',
      title: '7Loves Topluluk Kuralları',
      subtitle: 'Saygılı, güvenli ve pozitif bir flört deneyimi için kurallarımız.',
      sections: [
        {
          title: '7Loves Topluluğuna Hoş Geldiniz!',
          blocks: [
            {
              type: 'paragraph',
              content:
                "Bu kurallar, 7Loves'u herkes için güvenli, samimi ve olumlu bir ortam olarak tutmak için tasarlanmıştır. 7Loves'u kullanarak; eşleşmeleriniz, diğer kullanıcılar veya ekibimizle etkileşim kurarken her zaman bu kurallara uymayı kabul edersiniz.",
            },
          ],
        },
        {
          title: '1. Yalnızca Yetişkinler - Gerçek İnsanlar, Gerçek Niyetler',
          blocks: [
            {
              type: 'paragraph',
              content:
                "7Loves, 18 yaş ve üzerindeki kişiler içindir. Gerçek kimliğinizi kullanmalı ve doğru bilgi vermelisiniz. Başkasının kimliğini kullanmak, yaşınızı gizlemek veya yanlış bilgi vermek kesinlikle yasaktır.",
            },
          ],
        },
        {
          title: '2. Kendiniz Olun',
          blocks: [
            {
              type: 'list',
              items: [
                'Profil fotoğraflarınız ve açıklamalarınız sizi dürüstçe temsil etmelidir. Düzenlenmiş, ağır filtre uygulanmış veya yanıltıcı görseller kullanmayın.',
                'Tüm fotoğraflar yüzünüzü net biçimde göstermeli ve flört ortamına uygun olmalıdır. Ana profil fotoğrafı olarak grup fotoğrafı kullanmayın.',
                'Cinsel içerikli, pornografik, şiddet içeren veya rahatsız edici görsellere izin verilmez.',
              ],
            },
          ],
        },
        {
          title: '3. Saygı ve Empati',
          blocks: [
            {
              type: 'list',
              items: [
                'Her kullanıcı saygıyı hak eder. Taciz, zorbalık, yıldırma, ayrımcılık veya nefret söylemine tolerans gösterilmez.',
                'Irk, din, milliyet, cinsiyet, cinsel yönelim, yaş veya engellilik temelinde insanları hedef alan dil veya görseller kullanmayın.',
                'Tehdit, küfürlü dil veya tekrarlayan istenmeyen iletişim yasaktır.',
              ],
            },
          ],
        },
        {
          title: '4. Anlamlı ve Saygılı İletişim',
          blocks: [
            {
              type: 'list',
              items: [
                'Tüm mesajlar ve etkileşimler saygılı ve rızaya dayalı olmalıdır. Şaka amaçlı olsa bile cinsel veya taciz edici mesajlar göndermeyin.',
                'Spam, tekrarlayan veya ilgisiz mesajlar göndermeyin.',
                'Birisi ilgilenmiyorsa veya durmanızı istiyorsa buna saygı duymalısınız.',
              ],
            },
          ],
        },
        {
          title: '5. Hassas Bilgi Talepleri Yasaktır',
          blocks: [
            {
              type: 'list',
              items: [
                'Uygulama üzerinden telefon numarası, adres, banka veya kredi kartı bilgileri gibi özel ve hassas bilgileri istemeyin veya paylaşmayın.',
                'Parolanızı asla paylaşmayın ve hesabınızı başkalarının kullanmasına izin vermeyin.',
                'Para veya başka değerli şeyler istemeyin ya da göndermeyin.',
              ],
            },
          ],
        },
        {
          title: '6. Şiddet ve Sömürüye Sıfır Tolerans',
          blocks: [
            {
              type: 'list',
              items: [
                'Şiddeti, sömürüyü, istismarı veya yasa dışı faaliyeti teşvik eden, yücelten veya tehdit eden içerik ya da davranışlara izin verilmez.',
                'Çocukların cinselleştirilmesi, istismarı veya çocuk görsellerinin paylaşılması (gerçek ya da kurgusal) kesinlikle yasaktır ve yetkililere bildirilir.',
                'Tehditler, doxxing veya zarar vermeye teşvik eden girişimler hesabın derhal kaldırılması için gerekçedir.',
              ],
            },
          ],
        },
        {
          title: '7. Ticari Faaliyet ve Talep Yasağı',
          blocks: [
            {
              type: 'list',
              items: [
                '7Loves; işletme tanıtımı, satış, reklam, işe alım, çok katlı pazarlama veya herhangi bir finansal talep için kullanılamaz.',
                '"Sugar dating", eskort hizmetleri veya karşılıklı çıkar ilişkisi taleplerine izin verilmez.',
              ],
            },
          ],
        },
        {
          title: '8. Spam, Dolandırıcılık ve Kötüye Kullanım',
          blocks: [
            {
              type: 'list',
              items: [
                'Spam, dolandırıcılık, sahte çekilişler, saadet zincirleri veya aldatıcı bağlantılar göndermeyin ya da bunları teşvik etmeyin.',
                'Diğer kullanıcıların, markaların veya kamuya mal olmuş kişilerin kimliğine bürünmeyin.',
                "7Loves ile etkileşim kurmak için botlar, betikler veya yetkisiz üçüncü taraf uygulamalar kullanmayın.",
              ],
            },
          ],
        },
        {
          title: '9. Bildirim ve Güvenlik',
          blocks: [
            {
              type: 'list',
              items: [
                'Şüpheli, taciz edici veya zararlı davranış görürseniz, bunu uygulama içi bildirim aracıyla veya destek ekibiyle iletişime geçerek hemen bize bildirin.',
                'Tüm bildirimler ciddiyetle ele alınır ve gizli şekilde değerlendirilir.',
                'Kötü niyetle yapılan asılsız bildirimler de bu kuralların ihlalidir.',
              ],
            },
          ],
        },
        {
          title: '10. İhlallerin Sonuçları',
          blocks: [
            {
              type: 'list',
              items: [
                'Bu kuralların ihlali; içeriğin kaldırılmasına, uyarılara, hesabınızın geçici veya kalıcı olarak askıya alınmasına ya da gerekirse hukuki işleme yol açabilir.',
                'Çocuk güvenliği ihlalleri, tehdit veya taciz gibi ağır ihlaller anında ve kalıcı yasaklamaya neden olur ve kolluk kuvvetlerine bildirilebilir.',
              ],
            },
          ],
        },
        {
          title: '11. Topluluk Güvenliği Herkesin Sorumluluğudur',
          blocks: [
            {
              type: 'paragraph',
              content:
                '7Loves’un bir parçası olarak herkes için samimi, güvenli ve kapsayıcı bir topluluk kurmamıza yardımcı olmayı kabul edersiniz. Başkalarına görmek istediğiniz şekilde davranın. Bunu birlikte olumlu bir deneyim haline getirelim.',
            },
          ],
        },
        {
          title: '12. Çocuk Güvenliği',
          blocks: [
            {
              type: 'list',
              items: [
                'Seven Loves, çocukların cinsel istismarı ve sömürüsüne (CSAE) karşı sıfır tolerans politikası uygular.',
                'Kullanıcılar 18 yaşında veya daha büyük olmalıdır.',
                'Küçükleri içeren her türlü içerik kesinlikle yasaktır.',
                'Bu tür içerikleri aktif biçimde kaldırır ve bildiririz.',
                'Kullanıcılar uygunsuz içerikleri uygulama içinden bildirebilir.',
                <>İletişim: {emailLink()}</>,
              ],
            },
          ],
        },
        {
          title: '13. Güncellemeler ve İletişim',
          blocks: [
            {
              type: 'paragraph',
              content: (
                <>
                  7Loves bu kuralları herhangi bir zamanda güncelleme hakkını saklı tutar.
                  Değişiklikler için lütfen kuralları düzenli olarak inceleyin. Sorularınız varsa
                  veya desteğe ihtiyaç duyarsanız bizimle <b>team@sevenloves.co.uk</b> üzerinden
                  iletişime geçin.
                </>
              ),
            },
          ],
        },
      ],
    },
    dateSafety: {
      metaTitle: 'Flört Güvenliği',
      title: 'Flört Ederken Güvende Kalın',
      subtitle:
        'Güvenliğiniz en büyük önceliğimizdir. 7Loves üzerindeki güvenli ve saygılı bağlantılar için ipuçlarımız ve kurallarımız burada.',
      sections: [
        {
          title: 'Gizliliğinizi Koruyun',
          blocks: [
            {
              type: 'list',
              items: [
                'Ev adresinizi, iş yerinizi veya özel iletişim bilgilerinizi (telefon numarası ya da e-posta gibi) çok erken paylaşmayın.',
                "7Loves'ta tanıştığınız hiç kimseye para veya finansal bilgi göndermeyin.",
                'Özellikle henüz yüz yüze görüşmediyseniz, kişisel fotoğraflarınızı paylaşırken dikkatli olun.',
              ],
            },
          ],
        },
        {
          title: 'Yüz Yüze Buluşma',
          blocks: [
            {
              type: 'list',
              items: [
                'İlk buluşma için her zaman halka açık bir yerde buluşun (örneğin bir kafe, restoran veya kalabalık bir park).',
                'Bir arkadaşınıza veya aile üyenize planlarınızı söyleyin: nereye gittiğinizi, kiminle buluşacağınızı ve ne zaman dönmeyi beklediğinizi paylaşın.',
                'Ulaşımınızı kendiniz organize edin ve telefonunuzun şarjı dolu olsun; telefonunuzu her zaman yanınızda taşıyın.',
                'Sizi rahatsız eden hiçbir şey için baskı altında hissetmeyin. İçgüdülerinize güvenin; bir şey ters gelirse oradan ayrılın.',
              ],
            },
          ],
        },
        {
          title: 'Çevrim İçi Etkileşimler',
          blocks: [
            {
              type: 'list',
              items: [
                'Biri sizden para isterse, kriz yaşadığını söylerse veya sizi hızla uygulama dışına çıkarmaya çalışırsa dikkatli olun. Bunlar dolandırıcılık işareti olabilir.',
                'Yüz yüze buluşmayı veya görüntülü konuşmayı reddeden kullanıcılara karşı temkinli olun.',
                'Sahte profillere ve başkasının fotoğraflarını kullanan kişilere dikkat edin. Şüpheli gelen bir durum varsa bize bildirin.',
              ],
            },
          ],
        },
        {
          title: 'Bildirme ve Engelleme',
          blocks: [
            {
              type: 'list',
              items: [
                'Kendinizi güvensiz, rahatsız veya saygısızlığa uğramış hissettiren her davranış için uygulama içi bildirme ve engelleme özelliklerimizi kullanın.',
                'Tüm bildirimleri inceler ve topluluğumuzu korumak için hızlı aksiyon alırız.',
                'Tehdit altında hissediyorsanız veya acil tehlike varsa derhal yerel yetkililerle iletişime geçin.',
              ],
            },
          ],
        },
        {
          title: 'Birbirimize Göz Kulak Olalım',
          blocks: [
            {
              type: 'list',
              items: [
                'Şüpheli, sahte veya kötüye kullanım içeren hesaplar görürseniz bildirin. 7Loves’u herkes için güvenli tutmamıza yardımcı olun.',
                "Birinin 18 yaşından küçük olduğunu öğrenirseniz bildirin. 7Loves'ta yalnızca yetişkinlere izin verilir.",
                'Herkesin kendini güvende, saygı görmüş ve desteklenmiş hissettiği bir topluluk oluşturalım.',
              ],
            },
          ],
        },
        {
          title: 'Ek Kaynaklar',
          blocks: [
            {
              type: 'paragraph',
              content: 'Daha fazla ipucu ve destek için şu kaynaklara göz atabilirsiniz:',
            },
            {
              type: 'list',
              items: [
                externalLink(
                  'https://www.met.police.uk/advice/advice-and-information/sa/sexual-assault/keeping-safe-on-a-date/',
                  'Met Police: Keeping Safe on a Date'
                ),
                externalLink(
                  'https://www.onlinedatingassociation.org.uk/safety/',
                  'Online Dating Association: Safety Centre'
                ),
                externalLink('https://www.getsafeonline.org/', 'Get Safe Online'),
              ],
            },
          ],
        },
        {
          title: 'Bize Ulaşın',
          blocks: [
            {
              type: 'paragraph',
              content: (
                <>
                  Kendinizi güvensiz hissederseniz, yardıma ihtiyaç duyarsanız veya herhangi bir
                  endişeniz olursa lütfen ekibimizle <b>team@sevenloves.co.uk</b> adresinden
                  iletişime geçin.
                </>
              ),
            },
          ],
        },
      ],
    },
    deleteAccount: {
      metaTitle: 'Hesabı Sil',
      title: 'Hesabınızı Silin - Seven Loves: Blind Date Dating App',
      subtitle:
        'Seven Loves: Blind Date Dating App, Seven Loves Limited tarafından geliştirilir ve işletilir.',
      blocks: [
        {
          type: 'paragraph',
          content:
            'Seven Loves, kullanıcıların başkalarıyla bağlantı kurmasına ve eşleşmesine imkan tanıyan bir flört uygulamasıdır.',
        },
        {
          type: 'paragraph',
          content:
            "Seven Loves hesabınızı ve ilişkili verilerinizi kalıcı olarak silmek istiyorsanız, aşağıdaki süreci kullanarak hesap silme talebinde bulunabilirsiniz.",
        },
      ],
      sections: [
        {
          title: 'Hesabınızı nasıl silebilirsiniz?',
          blocks: [
            {
              type: 'list',
              items: [
                <>Bize {emailLink()} adresine e-posta gönderin</>,
                'Hesabınızla ilişkili e-posta adresini veya telefon numarasını ekleyin',
                'Ekibimiz talebinizi doğrulayacaktır',
              ],
            },
          ],
        },
      ],
      footerBlocks: [
        {
          type: 'paragraph',
          content:
            'Talebiniz onaylandıktan sonra hesabınız ve ilişkili tüm verileriniz 7 gün içinde kalıcı olarak silinecektir.',
        },
        {
          type: 'paragraph',
          content:
            'Kullanıcılar hesaplarını doğrudan uygulama içinden de silebilir.',
        },
        {
          type: 'paragraph',
          content: (
            <>
              Daha fazla yardıma ihtiyaç duyarsanız bizimle {emailLink()} üzerinden iletişime
              geçin.
            </>
          ),
        },
        {
          type: 'paragraph',
          content: (
            <>
              Seven Loves Limited
              <br />
              {externalLink('https://sevenloves.co.uk', 'https://sevenloves.co.uk')}
            </>
          ),
        },
      ],
    },
  },
};

export default tr;
